<template>
<div style="margin:20px">
  <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
    <span style="font-size: 26px; font-weight: bold">Actuals - Multiday Ontime Performance Report</span><br/>
    <span style="font-style: italic; font-size: 18px">this report highlights differences between planned & actual times.  Select a yard and thresholds and rerun to filter results.</span>
  </div>
  <div style="position: relative; font-weight: bold; font-size: 24px" class="align-right d-flex align-items-center justify-content-center">
    <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
    &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
    &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
    &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
    &nbsp;&nbsp;&nbsp;
    <span v-if="base_options && base_options.length > 2">Yard: <b-form-select v-model="selected_base" :options="base_options" style="font-size: 20px; font-weight: bold; width:240px"/>&nbsp;&nbsp;</span>
  </div>
  <div style="margin-top: 30px; position: relative; font-weight: bold; font-size: 20px" class="align-right d-flex align-items-center justify-content-center">
    Consecutive Days&nbsp;<b-form-select v-model="day_threshold" :options="daysOptions" style="font-size: 20px; font-weight: bold; width:60px"/>
    &nbsp;&nbsp;
    Total Diff &nbsp;<b-form-select v-model="total_threshold" :options="threshold_options" style="font-size: 20px; font-weight: bold; width:90px"/>
    &nbsp;&nbsp;
    Start Diff &nbsp;<b-form-select v-model="start_threshold" :options="threshold_options" style="font-size: 20px; font-weight: bold; width:90px"/>
    &nbsp;&nbsp;
    Finish Diff &nbsp;<b-form-select v-model="finish_threshold" :options="threshold_options" style="font-size: 20px; font-weight: bold; width:90px"/>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <b-button v-on:click.prevent="load_data()" :disabled="loading">Run</b-button>
    &nbsp;&nbsp;
    <b-button size="md" variant="success" :disabled="loading" @click="download">Download</b-button>
  </div>

  <div v-if="!loading">
    <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
      <div class="col" style="border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
      <div @click="filter_by_status('total')" class="col" :style="selected_status=='total' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">Total Diffs: {{total_items.length}}</div>
      <div @click="filter_by_status('start')" class="col" :style="selected_status=='start' ? 'border: 2px solid red;' : 'border: 1px solid grey;'">Start Diff: {{start_items.length}}</div>
      <div @click="filter_by_status('finish')" class="col" :style="selected_status=='finish' ? 'border: 2px solid red;' : 'border: 1px solid grey;'">Finish Diff: {{finish_items.length}}</div>
      <div @click="filter_by_status('ontime')" class="col ontime" :style="selected_status=='ontime' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">On Time: {{ontime_items.length}}</div>
      <div @click="filter_by_status('early')" class="col early" :style="selected_status=='early' ? 'border: 2px solid red;' : 'border: 1px solid grey;'">Early: {{early_items.length}}</div>
      <div @click="filter_by_status('late')" class="col late" :style="selected_status=='late' ? 'border: 2px solid red;' : 'border: 1px solid grey;'">Late: {{late_items.length}}</div>
    </div>
  </div>

  <table v-if="!loading" width="100%" border="1" cellpadding="2">
    <tr>
      <th colspan="4" style="font-size: 18px; font-weight: bold;">&nbsp;</th>
      <th style="background-color: lightgrey" colspan="3" v-for="time_field in summary.time_fields" @click="sort_dates('planned' + time_field + 'DateTime')">{{time_field}}</th>
    </tr>
    <tr>
      <th width="60px" @click="sort_numbers('charterID')">Booking ID</th>
      <th width="60px" @click="sort_strings('vehicle')">Vehicle</th>
      <th width="60px" @click="sort_strings('driver')">Driver</th>
      <th width="60px" @click="sort_strings('total_delta')">Total Diff</th>
      <template v-for="time_field in summary.time_fields">
        <th width="60px" @click="sort_dates('planned' + time_field + 'DateTime')">Planned</th>
        <th width="60px" @click="sort_dates('actual' + time_field + 'DateTime')">Actual</th>
        <th width="30px" @click="sort_numbers(time_field + 'Delta')">Diff</th>
      </template>
    </tr>
    <template v-for="item in items">
      <tr>
        <td align="center">{{ item.bookingID }}</td>
        <td align="center">{{ item.vehicle }}</td>
        <td align="center">{{ item.driver }}</td>
        <td v-if="item.total_delta && item.total_delta < 0" class="early">{{item.total_delta}}m</td>
        <td v-else-if="item.total_delta && item.total_delta > 0" class="late">{{item.total_delta}}m</td>
        <td v-else>&nbsp;</td>
        <template v-for="time in item.times">
          <td>{{format_local(time.planned, item.timezone)}}</td>
          <td>{{format_local(time.actual, item.timezone)}}</td>
          <td v-if="time.actual && time.delta < 0" class="early">{{time.delta}}m</td>
          <td v-else-if="time.actual && time.delta > 0" class="late">{{time.delta}}m</td>
          <td v-else-if="time.delta">{{time.delta}}m</td>
          <td v-else>&nbsp;</td>
        </template>
      </tr>
    </template>
  </table>
  <div v-else>
    <br/><br/>
    <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
  </div>
</div>

</template>
<script>
import {api_url, get_tbn_multiday_otp_report } from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'actuals_multiday_otp_report_tbn',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      total_items: [],
      start_items: [],
      finish_items: [],
      ontime_items: [],
      early_items: [],
      late_items: [],
      base_options: [],
      summary: [],
      day_threshold: 1,
      start_threshold: 5,
      finish_threshold: 5,
      total_threshold: 5,
      selected_status: null,
      selected_base: '',
      daysOptions: [
        { value: '', text: '' },
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' }
      ],
      threshold_options: [
        { value: '1', text: '1m' },
        { value: '5', text: '5m' },
        { value: '10', text: '10m' },
        { value: '15', text: '15m' },
        { value: '20', text: '20m' },
        { value: '30', text: '30m' },
        { value: '45', text: '45m' },
        { value: '60', text: '1h' },
        { value: '120', text: '2h' },
        { value: '240', text: '4h' },
      ],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      details_toDate: justDate(moment().subtract(1, 'days')),

      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(180, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: {data = []}} = await get_tbn_multiday_otp_report(this.user.tenant, this.selected_base, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), this.day_threshold, this.start_threshold, this.finish_threshold, this.total_threshold)
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.base_options = data.summary.bases
        this.filter_items()
        this.calc_otp_status()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    format_local(value, tz) {
      // tz is set per row from the booking's originating yard so multi-yard tenants render correctly;
      // falls back to the summary timezone (tenant default) for older payloads that don't carry it.
      if (!value || typeof value !== 'string') return ''
      const m = moment(String(value))
      const effective_tz = tz || (this.summary && this.summary.timezone)
      if (effective_tz) m.tz(effective_tz)
      return m.format('MM/DD hh:mm A')
    },
    async calc_otp_status() {
      if (this.items && this.items.length > 0) {

        for (const item of this.items) {
          let otp_status = ''
          let has_early = false
          let has_late = false

          if (item.total_delta && Math.abs(item.total_delta) >= this.total_threshold) {
            otp_status += '+total'
          }

          for (const time of item.times) {
            if (time.actual && time.field === 'Driver Start Time' && Math.abs(time.delta) >= this.start_threshold) {
              otp_status += '+start'
              if (time.delta < 0) {
                has_early = true
              } else if (time.delta > 0) {
                has_late = true
              }
            } else if (time.actual && time.field === 'Driver Finish Time' && Math.abs(time.delta) >= this.finish_threshold) {
              otp_status += '+finish'
              if (time.delta < 0) {
                has_early = true
              } else if (time.delta > 0) {
                has_late = true
              }
            }
          }
          
          // Determine early/late/ontime status
          if (has_early && !has_late) {
            item.otp_timing_status = 'early'
          } else if (has_late && !has_early) {
            item.otp_timing_status = 'late'
          } else if (has_early && has_late) {
            item.otp_timing_status = 'late' // If both, consider it late
          } else {
            item.otp_timing_status = 'ontime'
          }
          
          item.otp_status = otp_status
        }
      }
      this.total_items = this.items_full.filter(item => item.otp_status.indexOf('total') != -1)
      this.start_items = this.items_full.filter(item => item.otp_status.indexOf('start') != -1)
      this.finish_items = this.items_full.filter(item => item.otp_status.indexOf('finish') != -1)
      this.ontime_items = this.items_full.filter(item => item.otp_timing_status === 'ontime')
      this.early_items = this.items_full.filter(item => item.otp_timing_status === 'early')
      this.late_items = this.items_full.filter(item => item.otp_timing_status === 'late')
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.selected_type)
        this.items = this.items.filter(item => item.booking_type == this.selected_type)
      if (this.selected_status) {
        if (this.selected_status === 'ontime' || this.selected_status === 'early' || this.selected_status === 'late') {
          this.items = this.items.filter(item => item.otp_timing_status === this.selected_status)
        } else {
          this.items = this.items.filter(item => item.otp_status.indexOf(this.selected_status) != -1)
        }
      }
      if (this.booking_filter)
        this.items = this.items.filter(item => (this.contains(item.bookingID, this.booking_filter) || this.contains(item.driver, this.booking_filter) || this.contains(item.vehicle, this.booking_filter)))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    filter_by_status(status) {
      if (status == null || this.selected_status == status) {
        this.selected_status = null
      } else {
        this.selected_status = status
      }
      this.filter_items()
    },
    sort_dates(col) {
      console.log("sort_dates:" + col)
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a < b) {
            return -1;
          }
        })
      }
      this.sort_col = col
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      const statusFilter = (this.selected_status === 'ontime' || this.selected_status === 'early' || this.selected_status === 'late') ? this.selected_status : null
      axios.post(
          `${api_url}tbn/reports/actuals/multiday/otp/download`,
          {
            tenant: this.user.tenant,
            base: this.selected_base,
            dayThreshold: this.day_threshold,
            startThreshold: this.start_threshold,
            finishThreshold: this.finish_threshold,
            totalThreshold: this.total_threshold,
            status: statusFilter,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const tenantShort = this.user.tenant.split('-')[0]
        const statusSuffix = statusFilter ? `-${statusFilter}` : ''
        link.setAttribute(
            'download',
            `actuals-multiday-otp-tbn-${tenantShort}${statusSuffix}-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger', 5000)
      })
    },

  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
  }
}
</script>

<style>

.early {
  background-color: hsla(120, 100%, 75%, 0.2)
}

.late {
  background-color: rgba(255, 0, 0, 0.2)
}

.ontime {
  background-color: hsla(200, 75%, 50%, 0.2)
}

</style>
